import "../general.scss";
import { debounce } from "throttle-debounce";
import { Bootstrapper } from "../Bootstrapper";

export class StyleBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        // Listen for vertical height changes to update the CSS property
        const listenForResize = debounce(500, () => {
            document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
        }, {
            atBegin: false,
        });

        window.addEventListener("resize", listenForResize);
        listenForResize();
    }
}
